import React, {useState, useCallback, useEffect, useMemo} from 'react';
import {StyleSheet} from 'react-native'
import {Button, Card, Paragraph, Avatar, Text} from 'react-native-paper'
import Icon from 'react-native-vector-icons/FontAwesome'
import Colors from './Colors'
import Link from './Link'
import Fade from 'react-reveal/Fade'
import Jump from 'react-reveal/Jump'

const Screen = ({next, children}) => {
    const [opacity, setOpacity] = useState(1),
          iconStyle = useMemo(() => StyleSheet.compose(styles.icon,{opacity}), [opacity])
    
    useEffect(
        () => {
            const handler = setTimeout(() => setOpacity(opacity ? 0 : 1), (opacity ? 2750 : 1750))
            return () => clearTimeout(handler)
        },
        [opacity]
    )
             
    return <Paragraph style={styles.paragraph}>
             { children }
             <Icon
               name="arrow-right"
               style={iconStyle}
               size={17}
               onPress={next} />
           </Paragraph>
}

const Screens = [
    (
        <>
          We leverage the complex tools of the digital marketing landscape to help you
          optimize your workflow and maintain a competitive brand across the web and social
        </>
    ),
    (
        <>
          It takes more than just SEO - from website and mobile app development, to infrastructure management and monitoring,
          to advertising campaigns and analytics - engage existing customers more effectively
          while discovering untapped new audiences for growth
        </>
    ),
    (
        <>
          From Madison Avenue to Silicon Valley and now Miami, Florida, our team is backed by over 20 years of experience
          implementing technology used by iconic brands such as PBS, MTV, Univision, American Express, Yelp,
          The Economist, and Major League Baseball
        </>
    ),
    (
        <>
             Interested in finding out how we can assist your operations?
             Reach out.
        </>
    )
]
const CardWrapper = () => {
    const [idx, setIdx] = useState(0),
          screen = Screens[idx],
          next = useCallback(() => setIdx((idx >= (Screens.length - 1)) ? 0 : (idx + 1)), [idx]),
          jump = useMemo(() => idx === (Screens.length - 1), [idx])
    
     return <Card style={styles.card}>
             <Card.Title
               title={<Text>Agency EMB</Text>}
               subtitle={<Text style={{color: Colors.red}}>Marketing Technology</Text>}
               left={
                   props => <Avatar.Text
                              {...props}
                              style={styles.avatar}
                              label="Æ"
                            />
               }
             />
             <Card.Content style={styles.cardContent}>
               <Screen next={next} >{screen}</Screen>
             </Card.Content>
             <Card.Actions style={styles.cardActions}>
               <Text style={styles.contact}>
                 <Link href="mailto:contact@blackcatalog.io">
                   <Fade opposite delay={500} duration={1500} >
                     <Jump delay={400} when={jump} duration={1800}>
                       <Button
                         style={styles.button}
                         color={'rgb(200,175,175)'}
                         icon="email"
                         accessibilityLabel="Email"
                       >
                         <Text style={{color: 'black'}}>contact@agencyemb.com</Text>
                       </Button>
                     </Jump>
                   </Fade>
                 </Link>
               </Text>
             </Card.Actions>
           </Card>
}

const styles = StyleSheet.create({
    card: {
        backgroundColor: 'rgba(255,255,255,0.2)',
        maxHeight: 420,
        border: `1px #A8A8A8 solid`,
        borderRadius: 15
    },
    avatar: {
        backgroundColor: Colors.red
    },
    cardContent: {
	height: 180,
        backgroundColor: 'transparent'
    },
    contact: {
        flex: 1,
        textAlign: 'right'
    },
    paragraph: {
        backgroundColor: 'transparent'
    },
    button: {
        cursor: 'pointer',
        color: Colors.red
    },
    icon: {
        cursor: 'pointer',
        color: Colors.red,
        padding: 8
    }
})

export default CardWrapper

